import Icon from '../components/Icon.vue'

Icon.register({
  snowboarding: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M432 96c-26.5 0-48-21.5-48-48s21.5-48 48-48 48 21.5 48 48-21.5 48-48 48zM460.8 249.6l-83.5-62.9-66 30.5 52 39c14.9 11.2 22 30.2 18.1 48.4l-21.9 102c-2.2 10.1-9.1 17.8-17.8 21.9l90.8 33.1c9.7 3.5 20.2 3.1 29.5-1.3 12-5.6 26.3-0.4 31.9 11.6 5.6 12 0.4 26.3-11.6 31.9-11.6 5.5-24 8.2-36.5 8.2-10 0-20-1.8-29.7-5.3l-364.8-132.7c-21.8-7.9-39.1-23.8-48.9-44.8-5.6-12-0.4-26.3 11.6-31.9 12-5.6 26.3-0.4 31.9 11.6 4.4 9.4 12.1 16.5 21.8 20l38.7 14.1c-3.8-3.5-7-7.7-8.7-12.9-5.6-16.8 3.4-34.9 20.2-40.5l74.1-24.7v-53.1c0-24.4 13.6-46.3 35.4-57.2l41.2-20.6-16.4-5.5c-12.1-4.1-22-12.6-27.7-24l-29.1-58.1c-7.9-15.8-1.5-35 14.3-42.9s35-1.5 42.9 14.3l26.1 52.1 63.7 21.2c16.3 5.4 31.6 13.5 45.4 23.8l111.4 83.5c14.2 10.6 17 30.7 6.4 44.8-6.3 8.4-15.9 12.8-25.6 12.8-6.7 0-13.4-2.1-19.2-6.4zM316.4 301.3l-60.5-45.3v20.5c0 20.7-13.2 39-32.8 45.5l-85 28.4c-2.6 0.9-5.3 1.1-8 1.3l169.4 61.6c-2.9-6.1-4.3-12.9-2.8-20z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/snowboarding.js
// module id = null
// module chunks = 